import axios from '@/services/axios'

const state = {
  searches: [],
  activeSearchId: null
}

const mutations = {
  addSearch (state, payload) {
    state.searches.push(payload)
  },
  updateSearch (state, payload) {
    let index = state.searches.findIndex(s => s.id === parseInt(payload.id))
    state.searches.splice(index, 1, payload.data)
  },
  removeSearch (state, id) {
    for (let search of state.searches) {
      if (search.id === parseInt(id)) {
        let index = state.searches.indexOf(search)
        state.searches.splice(index, 1)
      }
    }
  },
  setSearches (state, payload) {
    state.searches = payload
  },
  setActiveSearchId (state, payload) {
    state.activeSearchId = parseInt(payload)
  }
}

const getters = {
  search: state => id => {
    return state.searches.find(s => s.id === parseInt(id))
  },
  searches: state => {
    return state.searches
  },
  active: state => {
    return state.searches.find(s => s.id === state.activeSearchId)
  }
}

const actions = {
  async getSearches (context) {
    const data = await axios.get('/saved-search/list')
    context.commit('setSearches', data.data)
    if (data.data.length > 0) {
      context.commit('setActiveSearchId', data.data[0].id)
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/search.js